export const onEnterKeyPress = (fn: () => any) =>
	(event: { which: number }) => event.which === 13 ? fn() : null;

// Generate props for a clickable element around an onClick effect, including making the
// element able to be tab-focused and activated with an Enter keypress
export const clickableProps = (onClick: () => any, preventDefault = true, tabIndex = 0) => ({
	onClick: preventDefault ? (e: any) => { e.preventDefault(); onClick(); } : onClick,
	onKeyPress: onEnterKeyPress(onClick),
	tabIndex
});

// Pass as `ref` prop to input field component & the input will be autofocused on load
export const focusComponent = (input: any) => input && input.focus();
